export class ResultPage {
    
    constructor(readonly data: any, readonly code: number){}

    isOk(){
        return this.code && this.code == 200;
    }

}